export const Home = () => {
  return (
    <>
      <h1>Home page</h1>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eum odio
        debitis mollitia modi. Quasi facilis tempore quam, quos repudiandae
        accusamus sequi perferendis dolor fugiat architecto, possimus asperiores
        voluptate. Dolore odio culpa a quae. Alias deleniti velit quam
        doloremque officiis commodi!
      </p>
    </>
  );
};
